<div class="course-overview p-4 pt-0">
  <div class="flex items-center justify-between mb-4">
    <div class="page-heading">
      <h3 class="text-2xl font-semibold text-neutral-800">
        Transactions on March 2020 payout for
      </h3>
      <h3 class="text-2xl font-semibold text-neutral-800">
        Ahmed hany (<span class="text-blue-600 cursor-pointer">#223</span>)
      </h3>
    </div>
    <div class="actions flex flex-row gap-4">
      <button class="btn px-6 py-3 bg-teal-50 rounded-[4px] gap-2 border-0">
        <svg-icon src="@assets/images/icons/payout-receipt-icon.svg" class="text-teal-600"></svg-icon>
        <span class="text-teal-600 font-semibold text-sm">Payout Receipt</span>
      </button>
      <button class="btn px-6 py-3 bg-blue-50 rounded-[4px] gap-2 border-0">
        <svg-icon src="@assets/images/icons/export-icon.svg" class="text-blue-600"></svg-icon>
        <span class="text-blue-600 font-semibold text-sm">Export CSV</span>
      </button>
    </div>
  </div>
  <div class="flex flex-col gap-4 mb-4">
    <div class="flex flex-row gap-4">
      @for (payment of paymentHistory; track payment) {
      <div class="relative flex flex-col gap-1 border border-[#E5E5E5] rounded-lg p-4 bg-white w-full">
        <span
          class="absolute left-0 top-auto bottom-auto w-[5px] h-12 rounded-tr-[50px] rounded-br-[50px] bg-blue-500"></span>
        <h5 class="text-xs font-normal text-[#666666]">{{payment.title}}</h5>
        @if (payment.type=== 'date') {
        <h5 class="text-lg font-bold text-[#3941FE]">
          {{payment.value | date:'MMMM y'}}</h5>
        }
        @if (payment.type=== 'currency') {
        <h5 class="text-lg font-bold text-[#3941FE]">{{payment.value | currency}}
        </h5>
        }
        @if (payment.type=== 'number') {
        <h5 class="text-lg font-bold text-[#3941FE]">{{payment.value}}</h5>
        }
        <svg-icon src="@assets/images/icons/question-mark-circle.svg"
          class="btn-icon absolute right-4 text-amber-600"></svg-icon>
      </div>
      }
    </div>
  </div>
  <div class="page-heading mb-4 flex items-center justify-between">
    <div class="actions flex gap-4">
      <!-- Filter -->
      <div class="relative">
        <button (click)="dropdown('filter')" class="btn-neutral">
          <svg-icon src="@assets/images/icons/filter.svg" class="btn-icon"></svg-icon>
          <span>Filter</span>
        </button>
        <div [class]="isDropdown['filter']?'hidden':''"
          class="bg-white shadow-lg rounded px-2.5 py-5 w-[226px] absolute z-10 border border-neutral-100 max-h-80 overflow-y-auto">
          <div class="form">
            <form [formGroup]="filterForm">
              <formly-form [form]="filterForm" [fields]="filterFormFields" [model]="filterFormModel">
              </formly-form>
            </form>
          </div>
          <div class="flex gap-2.5 border-t-neutral-100 border-t pt-4">
            <button (click)="resetFilter()" class="btn btn-outline-dark border-neutral-600">
              <span>Reset</span>
            </button>
            <button class="btn btn-dark bg-neutral-600 text-white">
              <span>Filter</span>
            </button>
          </div>
        </div>
      </div>
      <!-- Search With Dropdown -->
      <div class="input-combine flex">
        <div class="select2">
          <div class="relative">
            <a (click)="dropdown('course')" type="button" aria-haspopup="listbox" aria-expanded="true"
              aria-labelledby="listbox-label" class="btn-neutral rounded-r-none">
              <div class="selected-item truncate">Course ID</div>
              <svg-icon src="@assets/images/icons/chevron-down-solid.svg" class="btn-icon"></svg-icon>
            </a>
            <ul [class]="isDropdown['course']?'':'hidden'" tabindex="-1" role="listbox"
              aria-labelledby="listbox-label" aria-activedescendant="listbox-option-3" class="select-items "
              ng-reflect-ng-class="hidden">
              <li (click)="dropdown('course')" id="listbox-option-0" role="option" class="item">Item 1</li>
              <li (click)="dropdown('course')" id="listbox-option-0" role="option" class="item">Item 2</li>
              <li (click)="dropdown('course')" id="listbox-option-0" role="option" class="item">Item 3</li>
            </ul>
          </div>
        </div>
        <div class="input-group">
          <div class="group !rounded-l-none">
            <svg-icon src="@assets/images/icons/search2.svg" class="input-icon"></svg-icon>
            <input placeholder="Enter your full name" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="flex-3 w-full overflow-hidden card rounded-lg border border-neutral-100">
    <div class="card-subheader flex items-center justify-between px-6 py-5">
      <div class="flex items-center gap-1">
        <h6>Transactions</h6>
        <div class="tag tag-sm">100 Transactions</div>
      </div>
      <div class="actions flex flex-row gap-4">
        <button class="btn-neutral px-3">
          <svg-icon src="@assets/images/icons/dots-vertical.svg" class="btn-icon"></svg-icon>
        </button>
      </div>
    </div>
    <div class="card-body">
      <div class="courses-list">
        <!-- Table -->
        <div class=" datagrid-table relative overflow-x-auto">
          <table class="w-full min-w-[850px] text-left">
            <thead class="heading">
              <tr>
                <th scope="col" class="">
                  <div class="col-name">Transaction ID</div>
                </th>
                <th scope="col" class="">
                  <div class="col-name">Order ID</div>
                </th>
                <th scope="col" class="">
                  <div class="col-name">Date</div>
                </th>
                <th scope="col" class="">
                  <div class="col-name">Payment Method</div>
                </th>
                <th scope="col" class="w-28">
                  <div class="col-name">Channel</div>
                </th>
                <th scope="col" class="w-28">
                  <div class="col-name">Sale Price</div>
                </th>
                <th scope="col" class="w-28">
                  <div class="col-name">Net Amount</div>
                </th>
                <th scope="col" class="">
                  <div class="col-name">Instructor Earning</div>
                </th>
                <th scope="col" class="">
                  <div class="col-name">Thkee Earning</div>
                </th>
                <th scope="col" class="">
                  <div class="col-name">Payout Status</div>
                </th>
              </tr>
            </thead>
            <tbody>
              @for (data of dummyData; track data) {
              <tr class="hover:cursor-pointer">
                <td>
                  <span class="course-id">
                    <span (click)="openTransactionDrawer(data)" class="text-blue-600 cursor-pointer">
                      #{{ data.id }}
                    </span>
                  </span>
                </td>
                <td>
                  <span class="course-id">
                    <span (click)="openOrderDrawer(data)" class="text-blue-600 cursor-pointer">
                      #{{ data.order_id }}
                    </span>
                  </span>
                </td>
                <td>
                  <span class="course-id">
                    <span class="">
                      {{ data.request_date | date:'d MMMM y' }}
                    </span>
                  </span>
                </td>
                <td class="max-w-[170px]">
                  <span class="">
                    {{ data.payment_methode }}
                  </span>
                </td>
                <td class="max-w-[170px]">
                  <span class="">
                    {{ data.channel }}
                  </span>
                </td>
                <td>
                  {{data.sale_price | currency}}
                </td>
                <td>
                  {{data.net_amount | currency}}
                </td>
                <td>
                  <span class="course-price flex items-center">
                    <button class="btn btn-transparent p-1">
                      <svg-icon src="@assets/images/icons/down-circle.svg" tooltip="Co-Instructor Earning"
                        class="w-5 h-5">
                      </svg-icon>
                    </button>
                    {{ data.instructor_earning | currency }}
                  </span>
                </td>
                <td>
                  {{data.thkee_earning | currency}}
                </td>
                <td>
                  <div [class]="getStatus(data.status).bg" class="flex flex-col px-2.5 py-[5px] rounded-2xl">
                    <span [class]="getStatus(data.status).text" class="text-sm">{{data.status}}</span>
                  </div>
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="pagination flex items-center justify-between px-5">
          <div class="flex flex-row gap-4 items-center">
            <span class="text text-neutral-700 font-normal text-sm">Show Items:</span>
            <div class="form">
              <form [formGroup]="paginationForm">
                <formly-form [form]="paginationForm" [fields]="paginationFormFields" [model]="paginationFormModel">
                </formly-form>
              </form>
            </div>
            <span class="text text-neutral-700 font-normal text-sm">entries</span>
          </div>
          <div class="navigation">
            <nav aria-label="Page navigation example">
              <ul class="inline-flex">
                <li>
                  <a href="#" class="btn btn-outline">
                    <svg-icon src="@assets/images/icons/arrow-left.svg" class="btn-icon h-5 w-5">
                    </svg-icon>
                    <span>Previous</span>
                  </a>
                </li>
                <li>
                  <a href="#" class="btn btn-outline">1</a>
                </li>
                <li>
                  <a href="#" class="btn btn-outline">2</a>
                </li>
                <li>
                  <a href="#" aria-current="page" class="btn btn-outline active">3</a>
                </li>
                <li>
                  <a href="#" class="btn btn-outline">...</a>
                </li>
                <li>
                  <a href="#" class="btn btn-outline">4</a>
                </li>
                <li>
                  <a href="#" class="btn btn-outline">5</a>
                </li>
                <li>
                  <a href="#" class="btn btn-outline">
                    <span>Next</span>
                    <svg-icon src="@assets/images/icons/arrow-right.svg" class="btn-icon h-5 w-5">
                    </svg-icon>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Transaction details drawer -->
<app-drawer #transactionDrawer>
  <ng-container header>
    <!-- Header -->
    <div class="px px-6 py-5 bg-neutral-50 flex justify-between items-center">
      <h1 class="text-black font-semibold text-xl">Transaction ID #{{transactionData?.id}}</h1>
      <div class="flex justify-between items-center gap-3">
        <button [routerLink]="'/ecommerce/sales/transaction/'+transactionData?.id"
          class="flex gap-2 flex-row px-6 py-3 rounded-[4px] font-semibold text-sm text-neutral-900 border border-neutral-600 bg-transparent">
          Go to Transaction detail
          <svg-icon src="@assets/images/icons/arrow-top-right-on-square.svg" class="text-blue-600 w-4 h-4">
          </svg-icon>
        </button>
        <button (click)="transactionDrawer.close()" class="bg-neutral-100 rounded-[3px] w-6 h-6">
          <svg-icon src="@assets/images/icons/x-mark.svg" class="text-black w-3 h-3">
          </svg-icon>
        </button>
      </div>
    </div>
  </ng-container>

  <ng-container content>
    <app-transaction-details-overview [id]="transactionData?.id" [isSidebarComponent]="true">
    </app-transaction-details-overview>
  </ng-container>
</app-drawer>


<!-- Order details drawer -->
<app-drawer #orderDrawer>
  <ng-container header>
    <!-- Header -->
    <div class="px px-6 py-5 bg-neutral-50 flex justify-between items-center">
      <h1 class="text-black font-semibold text-xl">Order ID #{{orderData?.order_id}}</h1>
      <div class="flex justify-between items-center gap-3">
        <button [routerLink]="'/ecommerce/order/'+orderData?.order_id"
          class="flex gap-2 flex-row px-6 py-3 rounded-[4px] font-semibold text-sm text-neutral-900 border border-neutral-600 bg-transparent">
          Go to Order detail
          <svg-icon src="@assets/images/icons/arrow-top-right-on-square.svg" class="text-blue-600 w-4 h-4">
          </svg-icon>
        </button>
        <button (click)="orderDrawer.close()" class="bg-neutral-100 rounded-[3px] w-6 h-6">
          <svg-icon src="@assets/images/icons/x-mark.svg" class="text-black w-3 h-3">
          </svg-icon>
        </button>
      </div>
    </div>
  </ng-container>

  <ng-container content>
    <app-order-details-overview [id]="orderData?.order_id" [isSidebarComponent]="true"
      [orderDetails]="orderData"></app-order-details-overview>
  </ng-container>
</app-drawer>